import { Injectable } from '@angular/core';
import { BaseHttpClientService } from '../../base-http-client.service';
import { GetLessonsModel } from '../../../api-models/responses/lesson/GetLessonsModel';

@Injectable({
  providedIn: 'root',
})
export class GetLessonsService {
  constructor(private baseClient: BaseHttpClientService) {}

  call() {
    let res = this.baseClient.getWithAuth<GetLessonsModel>(
      `/api/v1/lesson/get_lessons`
    );

    return res;
  }
}
